import { OrderService } from "@/services/order.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

const state = {
  id: "",
  state: {}
};

const getters = {
  getStateByKey: state => key => {
    return state.state[key] || null;
  }
};

const mutations = {
  SET_STATE(state, data) {
    state.id = data.id;
    state.state = data.state;
  }
};

const actions = {
  async fetchState({ commit }, id) {
    const state = await OrderService.getState(id).then(response =>
      JsonDenormalizer.denormalize(response.data)
    );
    commit("SET_STATE", state);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/orderState.module.js